import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Apiservice from '../Apiservice';

const KETAdd = () => {
    const location = useLocation();
    const user_id = location.state?.user_id || 0;
    const site_id = location.state?.site_id > 0 ? location.state?.site_id : 0;
    const role_id = location.state?.staffRoleId || 0;
    console.log('roleId at Initial', role_id)
    const navigate = useNavigate();

    const [user, setUser] = useState({});
    const [allSites, setAllSites] = useState([]);
    const [selectedSiteId, setSelectedSiteId] = useState(site_id);
    const [siteName, setSiteName] = useState("");
    const [siteAddress, setSiteAddress] = useState("")
    const [selectedSalaryDate, setSelectedSalaryDate] = useState("");
    const [selectedOvertimeDate, setSelectedOvertimeDate] = useState("");

    const refs = {
        companyRef: useRef(""),
        fullNameRef: useRef(""),
        nricOrFin: useRef(""),
        employmentStartDate: useRef(""),
        employmentEndDate: useRef(""),
        jobTitle: useRef(""),
        duties: useRef(""),
        employmentType: useRef(""),
        workingHours: useRef(""),
        breakHours: useRef(""),
        noOfWorkingDaysPerWeek: useRef(""),
        restDaysPerWeek: useRef(""),
        salaryPeriod: useRef(""),
        overtimeSalaryPeriod: useRef(""),
        datesOfSalaryPayment: useRef(""),
        datesOfOvertimePayment: useRef(""),
        salaryEffectiveDate: useRef(""),
        basicRateOfPay: useRef(57),
        grossRateOfPay: useRef(0),
        overtimeRateOfPay: useRef(""),
        salaryPaymentDates: useRef(""),
        overtimePaymentDates: useRef(""),
        paidAnualLeavePerYear: useRef(""),
        paidSickLeavePerYear: useRef(""),
        paidHospitalLeavePerYear: useRef(""),
        others: useRef(""),
        medicalBenefits: useRef(""),
        otherBenefits: useRef(""),
        lengthOfProbation: useRef(""),
        probationStartDate: useRef(""),
        probationEndDate: useRef(""),
        terminationDuringProbation: useRef(""),
        terminationAfterConfirmation: useRef("")
    };

    const fieldNameMap = {
        "Company Name": "companyRef",
        "Employee Full Name": "fullNameRef",
        "Employee NRIC/FIN": "nricOrFin",
        "Employment Start Date": "employmentStartDate",
        "Employment End Date (Only applicable for Fixed Term Contract)": "employmentEndDate",
        "Job title": "jobTitle",
        "Main Duties and Responsibilities": "duties",
        "Employment Type": "employmentType",
        "Details of working Hours": "workingHours",
        "Break During Work": "breakHours",
        "Number of working Days per week": "noOfWorkingDaysPerWeek",
        "Rest Day (Specify)": "restDaysPerWeek",
        "Salary Period": "salaryPeriod",
        "Overtime Payment Period": "overtimeSalaryPeriod",
        "Effective Date": "salaryEffectiveDate",
        "Basic Rate of Pay": "basicRateOfPay",
        "Gross Rate of Pay": "grossRateOfPay",
        "Overtime Rate of Pay": "overtimeRateOfPay",
        "Date(s) of salary Payment": "datesOfSalaryPayment",
        "Date(s) of overtime Payment": "datesOfOvertimePayment",
        "Paid Anual Leave per Year": "paidAnualLeavePerYear",
        "Paid Outpatiend Sick Leave Per Year": "paidSickLeavePerYear",
        "Paid Hospitalization Leave Per Year": "paidHospitalLeavePerYear",
        "Others": "others",
        "Medical Benefits": "medicalBenefits",
        "Length of Probation": "lengthOfProbation",
        "Probation Start Date": "probationStartDate",
        "Probation End Date": "probationEndDate",
        "Termination Period During Probation": "terminationDuringProbation",
        "Termination Period After Confirmation": "terminationAfterConfirmation"
    };

    const [formSections] = useState([
        {
            heading: "Section A | Details of Employment",
            fields: [
                { inputType: "text", field: "Company Name" },
                { inputType: "text", field: "Employee Full Name" },
                { inputType: "text", field: "Employee NRIC/FIN" },
                { inputType: "date", field: "Employment Start Date" },
                { inputType: "date", field: "Employment End Date (Only applicable for Fixed Term Contract)" },
                { inputType: "text", field: "Job title" },
                { inputType: "text", field: "Main Duties and Responsibilities" },
                { inputType: "text", field: "Employment Type" },
                { inputType: "text", field: "Site Name" },
                { inputType: "text", field: "Place of work" }
            ]
        },
        {
            heading: "Section B | Working Hours and Rest Days",
            fields: [
                { inputType: "text", field: "Details of working Hours" },
                { inputType: "number", field: "Number of working Days per week" },
                { inputType: "text", field: "Break During Work" },
                { inputType: "text", field: "Rest Day (Specify)" }
            ]
        },
        {
            heading: "Section C | Salary",
            fields: [
                { inputType: "text", field: "Salary Period" },
                { inputType: "text", field: "Overtime Payment Period" },
                { inputType: "date", field: "Date(s) of salary Payment" },
                { inputType: "date", field: "Date(s) of overtime Payment" },
                { inputType: "date", field: "Effective Date" },
                { inputType: "number", field: "Basic Rate of Pay" },
                { inputType: "number", field: "Gross Rate of Pay" },
                { inputType: "number", field: "Overtime Rate of Pay" }
            ]
        },
        {
            heading: "Section D | Leave and Medical Benefits",
            fields: [
                { inputType: "text", field: "Paid Anual Leave per Year" },
                { inputType: "text", field: "Paid Outpatiend Sick Leave Per Year" },
                { inputType: "text", field: "Paid Hospitalization Leave Per Year" },
                { inputType: "text", field: "Others" },
                { inputType: "text", field: "Medical Benefits" }
            ]
        },
        {
            heading: "Section E | Others",
            fields: [
                { inputType: "text", field: "Length of Probation" },
                { inputType: "text", field: "Probation Start Date" },
                { inputType: "text", field: "Probation End Date" },
                { inputType: "text", field: "Termination Period During Probation" },
                { inputType: "text", field: "Termination Period After Confirmation" }
            ]
        }
    ]);

    console.log("siteId", site_id)
    useEffect(() => {
        const fetchData = async () => {
            const result = await Apiservice.KETAddPage({ user_id, status: 0 });
            if (result.success) {
                setUser(result.user);
                refs.companyRef.current.value = result.user.companyName;
                refs.fullNameRef.current.value = `${result.user.firstName} ${result.user.lastName}`;
                refs.nricOrFin.current.value = result.user.nricOrFin;
                refs.jobTitle.current.value = result.user.designation;

                setAllSites(result.allSites);
                setSelectedSiteId(result.user.site_id || result.allSites[0]?.id || 0);
                let siteDetails = result.user.siteDetails;
                if (siteDetails.length > 0) {
                    setSiteName(siteDetails[0].name);
                }
            }
        };
        fetchData();
    }, []);

    const handleSave = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('user_id', parseInt(user_id));
        formData.append('role_id', parseInt(role_id));
        formData.append('site_id', parseInt(selectedSiteId));

        const salaryDate = refs.datesOfSalaryPayment.current?.value;
        const overtimeDate = refs.datesOfOvertimePayment.current?.value;

        let salaryDay = "";

        if (salaryDate) {
            const date = new Date(salaryDate);
            salaryDay = date.getDate();
        }
        let overtimeDay = "";
        if (overtimeDate) {
            const date = new Date(overtimeDate);
            overtimeDay = date.getDate();
        }


        for (let key in refs) {
            if (key !== "datesOfSalaryPayment" && key !== "datesOfOvertimePayment"){
                const value = refs[key]?.current?.value || '';
                formData.append(key, value);
            }
            else {
                 if (key === "datesOfSalaryPayment") {
                    formData.append(key, salaryDay)
                 }
                  if (key === "datesOfOvertimePayment") {
                    formData.append(key, overtimeDay);
                  }
            }

        }
        console.log(salaryDay, overtimeDay)

        const result = await Apiservice.AddKET(formData);
        if (result?.success) {
            alert(result.message);
            navigate(`/staffprofile/${user_id}`);
        } else {
            alert(result?.message || "Something went wrong");
        }
    };

    // const getSiteAddress = (siteId) => {

    //     if (siteId === 0 || siteId === '0') {
    //         console.log("hui")
    //         return "";
    //     }
    //     else {
    //         console.log("printed")
    //         const site = allSites.find(site => site.id === parseInt(siteId));
    //         if (site && site.address) {
    //             return `${site.address.unitNo}, ${site.address.street}, ${site.address.country} - ${site.address.pincode}`;
    //         }
    //         return '';
    //     }

    // };

    useEffect(() => {
        if (site_id !== 0 && site_id !== '0') {
            const site = allSites.find(site => site.id === parseInt(site_id));
            if (site && site.address) {
                const address = `${site.address.unitNo}, ${site.address.street}, ${site.address.country} - ${site.address.pincode}`;
                setSiteAddress(address);
            } else {
                setSiteAddress('');
            }
        } else {
            setSiteAddress('');
        }
    }, [site_id, allSites]);

    return (
        <div className="container border p-4">
            <h4 className="text-center mb-4">KEY EMPLOYMENT TERMS</h4>
            {formSections.map((section, secIndex) => (
                <div key={secIndex}>
                    <h5 className="mt-4 mb-3">{section.heading}</h5>
                    {section.fields.map((item, fieldIndex) => {
                        const refKey = fieldNameMap[item.field];
                        return (
                            <div className="row mb-2" key={fieldIndex}>
                                <div className="col-4">
                                    <label className="form-label">{item.field}</label>
                                </div>
                                <div className="col-1">:</div>
                                <div className="col-6">
                                    {
                                        item.field === 'Site Name' ? (
                                            // <select
                                            //     className="form-select form-select-sm"
                                            //     value={selectedSiteId}
                                            //     onChange={(e) => setSelectedSiteId(e.target.value)}
                                            // >
                                            //     {allSites.length > 0 ? (
                                            //         allSites.map(site => (
                                            //             <option key={site.id} value={site.id}>{site.name}</option>
                                            //         ))
                                            //     ) : (
                                            //         <option value="">No site available</option>
                                            //     )}
                                            // </select>
                                            <input
                                                type={item.inputType}
                                                className="form-control form-control-sm"
                                                value={siteName}
                                                readOnly
                                            />
                                        ) : item.field === "Place of work" ? (
                                            <input
                                                type={item.inputType}
                                                className="form-control form-control-sm"
                                                // value={getSiteAddress(selectedSiteId)}
                                                value={siteAddress}
                                                readOnly
                                            />
                                            // ) : item.field === "Date(s) of salary Payment" ? (
                                            //     <input
                                            //         type={item.inputType}
                                            //         className="form-control form-control-sm"
                                            //         // value={getSiteAddress(selectedSiteId)}
                                            //         value={selectedSalaryDate}
                                            //         onChange={(e) => setSelectedSalaryDate(e.target.value)}

                                            //     />
                                            // ) : item.field === "Date(s) of overtime Payment" ? (
                                            //     <input
                                            //         type={item.inputType}
                                            //         className="form-control form-control-sm"
                                            //         // value={getSiteAddress(selectedSiteId)}
                                            //         value={selectedOvertimeDate}
                                            //         onChange={(e) => setSelectedOvertimeDate(e.target.value)}

                                            //     />
                                        ) : (
                                            <input
                                                type={item.inputType}
                                                className="form-control form-control-sm"
                                                placeholder={item.field}
                                                ref={refKey ? refs[refKey] : null}
                                                readOnly={item.field === "Company Name" || item.field === "Employee Full Name" || item.field === "Employee NRIC/FIN" || item.field === "Job title"}
                                            />
                                        )
                                    }
                                </div>
                            </div>
                        );
                    })}
                </div>
            ))}
            <div className="row mt-4">
                <div className="col text-center">
                    <button className="btn btn-sm btn-primary" onClick={handleSave}>Save</button>
                </div>
            </div>
        </div>
    );
};

export default KETAdd;
